var $1ff90abddf42fc72$exports = {};
$1ff90abddf42fc72$exports = {
    "loading": `Y\xfckleniyor...`,
    "placeholder": `Se\xe7in\u{2026}`
};


export {$1ff90abddf42fc72$exports as default};
//# sourceMappingURL=tr-TR.module.js.map
